var os = function () {
    var ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;

    return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
    };
}();
console.log(os)
// pc时加载一套页面
if (os.isPc) {
    // location.replace("http://www.onlymid.com.cn/");
    // location.replace("http://127.0.0.1:5173");
}

// 移动端时加载另外一套页面 
if (os.isAndroid || os.isPhone) {
    // location.replace('http://www.onlymid.com.cn/html/2016shujia/wap/');
} else if (os.isTablet) {
    // location.replace('http://www.onlymid.com.cn/html/2016shujia/wap/');
}


// WEBPACK FOOTER //
// ./src/assets/js/fit.js